export enum AssistantPromptingTypeModel {
  FLOW_DESIGNER = "flow_designer",
  CUSTOM_PROMPT = "custom_prompt",
}
